import { render, staticRenderFns } from "./evaluationReport.vue?vue&type=template&id=227c253d&scoped=true"
import script from "./evaluationReport.vue?vue&type=script&lang=js"
export * from "./evaluationReport.vue?vue&type=script&lang=js"
import style0 from "./evaluationReport.vue?vue&type=style&index=0&id=227c253d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c253d",
  null
  
)

export default component.exports